import { Injectable } from '@angular/core';
import { AUTH } from 'src/app/constant/constant';

@Injectable({
  providedIn: 'root'
})
export class DomainContextService {

  private readonly defaultLogoSrc = 'assets/logo/logo-title.png';
  private readonly laoCaiLogoSrc = 'assets/logo/logo-laocai.png';

  private getCurrentUser(): any {
    const store = localStorage.getItem(AUTH.USER_INFO_KEY);
    if (!store) {
      return null;
    }
    try {
      return JSON.parse(store);
    } catch (e) {
      return null;
    }
  }

  getMaTinh(): string {
    const maTinh = localStorage.getItem('maTinh');
    if (maTinh) {
      return maTinh;
    }

    const user = this.getCurrentUser();
    return user && user.maTinhBhxh ? user.maTinhBhxh : '';
  }

  isLaoCai(): boolean {
    return this.getMaTinh() === '15';
  }

  
  isGiaLai(): boolean {
    return this.getMaTinh() === '52';
  }

  isLaoCaiLogoContext(): boolean {
    const user = this.getCurrentUser();
    if (user && user.maTinhBhxh) {
      return user.maTinhBhxh.toString() === '15' || user.maTinhBhxh.toString() === '52';
    }

    return this.isLaoCai() || this.isGiaLai();
  }

  isAdminUser(): boolean {
    const user = this.getCurrentUser();
    if (!user) {
      return false;
    }

    const danhSachNhomQuyen = user.danhSachNhomQuyen || [];
    const kyHieuList = danhSachNhomQuyen.map(item => item.KY_HIEU);
    return kyHieuList.includes('admin') || user.superAdmin === 1;
  }

  applyLaoCaiFlow(): boolean {
    return this.isLaoCai() && !this.isAdminUser();
  }

  getDefaultRoute(): any[] {
    return this.applyLaoCaiFlow()
      ? ['/btxh-ho-ngheo', 'danh-sach-ho-gia-dinh']
      : ['/trang-chu'];
  }

  getAppLabel(defaultLabel: string = 'An sinh xã hội'): string {
    return this.isLaoCai() ? 'Hộ nghèo, cận nghèo' : defaultLabel;
  }

  getLogoSrc(): string {
    return this.isLaoCaiLogoContext() ? this.laoCaiLogoSrc : this.defaultLogoSrc;
  }

  getFaviconSrc(): string {
    return this.getLogoSrc();
  }

  applyFavicon(): void {
    let favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;

    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }

    favicon.type = 'image/png';
    favicon.href = this.getFaviconSrc();
  }
}
